{
	"promo": {
		"title": "Вам открыт Pro на 12 месяцев",
		"subtitle": "Бесплатно на время промо-акции — все возможности StudyHub без ограничений.",
		"perks": {
			"unlimited": "Безлимитные конспекты, карточки и тесты",
			"ai": "Все AI-режимы и голосовой репетитор",
			"recordings": "Запись лекций и аудио-резюме без лимитов",
			"priority": "Приоритетная обработка"
		},
		"footnote": "По окончании промо-акции тариф вернётся к Free — данные сохранятся.",
		"cta": "Отлично"
	},
	"title": "Подписка",
	"currentPlan": "Текущий тариф",
	"tiers": {
		"free": "Free",
		"freeDescription": "Базовые функции для старта",
		"plus": "Plus",
		"plusDescription": "Расширенные лимиты и AI-режимы",
		"pro": "Pro",
		"proDescription": "Максимум возможностей и приоритет"
	},
	"pricing": {
		"perMonth": "{price} / месяц",
		"perYear": "{price} / год",
		"monthShort": "мес",
		"yearShort": "год",
		"save": "Скидка {percent}%",
		"trial": "Пробный период {days} дней",
		"monthly": "Месячно",
		"annual": "Годовая"
	},
	"upgrade": {
		"cta": "Перейти на {tier}",
		"ctaShort": "Улучшить тариф",
		"title": "Откройте больше возможностей",
		"subtitle": "Получите больше AI-операций и расширенные функции",
		"recommended": "Рекомендуем",
		"perks": {
			"plus": {
				"a": "Увеличенные лимиты на конспекты, карточки и тесты",
				"b": "Запись лекций и аудиосаммари",
				"c": "Голосовой репетитор и проверка эссе"
			},
			"pro": {
				"a": "Безлимитные конспекты, карточки и тесты",
				"b": "Все режимы AI с приоритетной обработкой",
				"c": "Более длинные записи и безлимитные аудиосаммари"
			}
		}
	},
	"paywall": {
		"quotaReached": "Вы достигли лимита тарифа",
		"featureLocked": "Эта функция доступна на тарифе {tier}",
		"upgrade": "Улучшить тариф",
		"later": "Позже",
		"triggers": {
			"quota_exceeded": "Лимит исчерпан",
			"pro_only_feature": "Доступно на Pro",
			"recording_limit": "Лимит записи лекций",
			"storage_limit": "Лимит хранилища",
			"voice_tutor_locked": "Голосовой репетитор — Plus или Pro",
			"audio_recap_locked": "Аудио-резюме — Plus или Pro",
			"trial_ending": "Ваш пробный период скоро закончится",
			"manual": "Улучшить тариф"
		},
		"feature": {
			"audio-recap": {
				"title": "Аудио-резюме — доступно на Plus",
				"description": "Превращайте материалы в подкасты, лекции, аудиокниги и короткие резюме — с разными стилями подачи и голосами.",
				"bullets": [
					"4 формата: подкаст, лекция, аудиокнига, резюме",
					"18 стилевых направлений на выбор",
					"Свои пожелания — настройте под себя"
				],
				"cta": "Перейти на Plus"
			}
		}
	},
	"cancel": {
		"action": "Отменить подписку",
		"confirmTitle": "Отменить подписку?",
		"confirmDescription": "Доступ к функциям {tier} сохранится до {date}.",
		"confirm": "Отменить",
		"keep": "Оставить",
		"reasonLabel": "Почему вы отменяете?",
		"reasons": {
			"too_expensive": "Слишком дорого",
			"not_useful": "Не нашёл применения",
			"missing_features": "Не хватает функций",
			"found_alternative": "Нашёл альтернативу",
			"other": "Другое"
		},
		"feedback": "Комментарий (необязательно)"
	},
	"history": {
		"title": "История платежей",
		"empty": "Платежей не было",
		"invoice": "Чек",
		"paid": "Оплачено",
		"refunded": "Возвращено",
		"failed": "Не оплачено"
	},
	"paymentMethod": {
		"title": "Способ оплаты",
		"yookassa": "ЮKassa",
		"paypal": "PayPal",
		"card": "Карта",
		"update": "Обновить способ оплаты",
		"infoYookassa": "Оплата на стороне YooKassa. Данные карты мы не храним.",
		"infoPaypal": "Оплата на стороне PayPal. Данные карты мы не храним."
	},
	"checkout": {
		"processing": "Создаём платёжную сессию…",
		"cancel": "Закрыть",
		"errorTitle": "Не удалось создать сессию"
	},
	"refund": {
		"statusTitle": "Запрос возврата",
		"status": {
			"pending": "На рассмотрении",
			"auto_approved": "Одобрено автоматически",
			"approved": "Одобрено",
			"rejected": "Отклонено",
			"processed": "Возвращено на счёт"
		},
		"submittedAt": "Отправлено {date}",
		"reasonLabel": "Причина",
		"reasons": {
			"ai_generation_failed": "AI-генерация не удалась",
			"service_outage": "Сбой сервиса",
			"other": "Другое"
		},
		"timelineTitle": "Хронология",
		"timeline": {
			"submitted": "Запрос отправлен",
			"reviewing": "На проверке",
			"decision": "Решение принято",
			"money_back": "Деньги вернулись"
		},
		"supportCta": "Связаться с поддержкой",
		"backCta": "К истории платежей",
		"notFound": "Запрос на возврат не найден"
	},
	"manage": {
		"title": "Управление подпиской",
		"subtitle": "Изменение тарифа, способа оплаты и отмена",
		"sections": {
			"changePlan": "Сменить тариф",
			"updatePayment": "Способ оплаты",
			"cancel": "Отменить подписку"
		},
		"changePlanCta": "Перейти к выбору",
		"changePlanHint": "Перейдите на другой тариф или измените цикл оплаты.",
		"updatePaymentCta": "Изменить",
		"updatePaymentHint": "Откроется страница провайдера для обновления карты или способа оплаты.",
		"cancelCta": "Отменить"
	},
	"pastDue": {
		"title": "Платёж не прошёл",
		"subtitle": "Обновите способ оплаты, чтобы сохранить доступ.",
		"daysLeft": "{count, plural, one {Осталось # день} few {Осталось # дня} other {Осталось # дней}} до перехода на Free",
		"updateCta": "Обновить оплату",
		"dismiss": "Скрыть"
	},
	"trial": {
		"daysLeft": "{count, plural, one {Остался # день} few {Осталось # дня} other {Осталось # дней}}",
		"dismiss": "Скрыть"
	},
	"iec": {
		"portalFailed": "Не удалось открыть личный кабинет IEC ID. Перенаправляем по прямой ссылке.",
		"checkoutFailed": "Не удалось открыть страницу оплаты. Попробуйте еще раз.",
		"trialUnavailable": "Пробный период недоступен для вашего аккаунта.",
		"planLabel": "Тариф {tier}",
		"expiresOn": "Действует до {date}",
		"renewWarning": "Продлите до {date}, иначе доступ завершится",
		"includedInPlusHint": "{tier} входит в подписку IEC+ — отдельный тариф StudyHub не требуется.",
		"localSubscriptionHint": "У вас есть активная подписка StudyHub — управляйте ею здесь.",
		"manageCta": "Управление IEC+",
		"manageLocalCta": "Управление тарифом StudyHub",
		"viewAllPlans": "Все тарифы",
		"source": {
			"subscription": "Подписка",
			"trial": "Пробный период",
			"gift": "Подарок",
			"grant": "Предоставлен",
			"other": "Доступ по экосистеме"
		},
		"trial": {
			"offerTitle": "Попробуйте {tier} бесплатно",
			"offerBody": "{count, plural, one {# день} few {# дня} many {# дней} other {# дней}} полного доступа. Карта не требуется — оплата только по вашему решению.",
			"offerCta": "Начать пробный период",
			"bannerTitle": "Пробный период {tier}",
			"bannerSubtitle": "После окончания пробного периода вы вернетесь на бесплатный тариф — списаний не будет.",
			"bannerCta": "Оформить подписку"
		},
		"return": {
			"pendingTitle": "Проверяем оплату",
			"pendingBody": "Доступ обычно открывается в течение минуты.",
			"confirmedTitle": "Доступ открыт",
			"confirmedBody": "Оплата подтверждена — ваш новый уровень уже активен.",
			"confirmedCta": "Продолжить",
			"timeoutTitle": "Оплата еще обрабатывается",
			"timeoutBody": "Подтверждение еще не поступило. Доступ включится автоматически — откройте эту страницу чуть позже.",
			"timeoutCta": "Понятно"
		}
	},
	"noSale": {
		"quotaReached": "Лимит действий исчерпан",
		"featureUnavailable": "Эта функция сейчас недоступна",
		"lockedTitle": "Пока недоступно",
		"lockedDescription": "Эта функция пока недоступна в приложении."
	}
}
